const eatEvent = event => {
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();
};

export default eatEvent;